// Models
import { RecurrencePatternType } from "../../../../service/planner/enumerations/IPlannerEnumerations";
import { MonthlyFixedDate } from "../calculator/MonthlyFixedDate";
import { MonthlyFloatingDay } from "../calculator/MonthlyFloatingDay";
import { WeeklyDay } from "../calculator/WeeklyDay";
import { YearlyFixedDate } from "../calculator/YearlyFixedDate";
import { YearlyFloatingDay } from "../calculator/YearlyFloatingDay";
/**
 * Get the DayOrDate objects given a Recurrence Pattern
 * @param recurrencePattern Recurrence pattern to get days or dates from
 */ export function getDaysOrDates(recurrencePattern) {
    switch(recurrencePattern.patternType){
        case RecurrencePatternType.Weekly:
            return recurrencePattern.daysOfWeek.map((dayOfWeek)=>new WeeklyDay(dayOfWeek));
        case RecurrencePatternType.FixedDayOfMonth:
            return [
                new MonthlyFixedDate(recurrencePattern.dayOfMonth)
            ];
        case RecurrencePatternType.FixedDayOfYear:
            return [
                new YearlyFixedDate(recurrencePattern.month, recurrencePattern.dayOfMonth)
            ];
        case RecurrencePatternType.RelativeDayOfMonth:
            return recurrencePattern.daysOfWeek.map((dayOfWeek)=>new MonthlyFloatingDay(recurrencePattern.weekIndex, dayOfWeek));
        case RecurrencePatternType.RelativeDayOfYear:
            return recurrencePattern.daysOfWeek.map((dayOfWeek)=>new YearlyFloatingDay(recurrencePattern.month, recurrencePattern.weekIndex, dayOfWeek));
        case RecurrencePatternType.Daily:
        default:
            // Daily has no day or date as it will be every day or interval day
            return null;
    }
}
